// GENERATED from palette.store by tools/palette-store.js — do not edit.
// Edit the store (or the knobs app Look tab), then re-run the generator.
//
// The canon ramps are copied from the hero pipeline's own spec
// (tools/heropipeline/spec/palette.json), which stays the source of truth
// for what canon looks like. The regions and swatches come from the
// store. Read it through shared/palette.ts, never this file directly.
export const PALETTE_DATA = {
  canon: {
    outline: "#2a1a1e",
    classes: {
      "boot": ["#4e3420", "#3a2616", "#68482c", "#2a1c10"],
      "cape": ["#a03050", "#7c2240", "#c04868", "#541830"],
      "cargo": ["#71803c", "#54602c", "#8e9c55", "#3c4520"],
      "gem": ["#40c8b0", "#2a9884", "#6ae0c8", "#1a6a5a"],
      "glint": ["#f6f2ea", "#f6f2ea", "#f6f2ea", "#f6f2ea"],
      "gold": ["#e0a838", "#b88420", "#f6c85e", "#8a5e12"],
      "hair": ["#8a4a26", "#66351a", "#a86034", "#4a2612"],
      "hood": ["#5a6a8a", "#42506c", "#74849f", "#2e3850"],
      "ink": ["#2a1a1e", "#2a1a1e", "#5a4a4e", "#2a1a1e"],
      "jacket": ["#2a8a74", "#1d6858", "#40ac92", "#124a3e"],
      "leather": ["#7c5230", "#5c3a20", "#9a6a42", "#422a14"],
      "leggings": ["#453a58", "#332b42", "#5c4e72", "#241e30"],
      "metal": ["#a0aebc", "#74818f", "#c9d4de", "#4e5a68"],
      "pants": ["#6e4c2c", "#523820", "#8a6440", "#3c2a16"],
      "satchel": ["#8a7a62", "#6a5c48", "#a89878", "#4c4232"],
      "scarf": ["#cc3a3a", "#a02626", "#e85c5c", "#7a1a1a"],
      "shade_boot": ["#4e3420", "#3a2616", "#68482c", "#2a1c10"],
      "shade_cape": ["#a03050", "#7c2240", "#c04868", "#541830"],
      "shade_hood": ["#5a6a8a", "#42506c", "#74849f", "#2e3850"],
      "shade_metal": ["#a0aebc", "#74818f", "#c9d4de", "#4e5a68"],
      "shade_satchel": ["#8a7a62", "#6a5c48", "#a89878", "#4c4232"],
      "shade_wood": ["#7a5a34", "#5c4224", "#96744a", "#42301a"],
      "shirt": ["#e6d9bd", "#c4b394", "#f4ecd6", "#9c8b6c"],
      "skin": ["#f2b283", "#d68e5e", "#ffd0a0", "#b06a3e"],
      "tunic": ["#3579cc", "#26589c", "#5c9ce0", "#1a3f78"],
      "vest": ["#c08a4a", "#96682f", "#d8a866", "#6e4a1e"],
      "wood": ["#7a5a34", "#5c4224", "#96744a", "#42301a"],
    },
  },
  toneRule: {
    shadow: { v: 0.76, s: 1 },
    light: { v: 1.1, s: 0.8 },
    deep: { v: 0.58, s: 1.05 },
  },
  groups: [
    {
      key: "top",
      label: "Tops",
      classes: ["tunic", "jacket", "shirt", "vest", "hood", "cape", "scarf", "shade_hood", "shade_cape"],
      swatches: [
        { id: 1, name: "Slate Blue", base: "#3579cc", shadow: "#285c9b", light: "#5c97e0", deep: "#1a4476" },
        { id: 2, name: "Forest", base: "#2f7a44", shadow: "#245d34", light: "#448657", deep: "#194726" },
        { id: 3, name: "Crimson", base: "#b83a3a", shadow: "#8c2c2c", light: "#ca5c5c", deep: "#6b1e1e" },
        { id: 4, name: "Sand", base: "#d8c08a", shadow: "#a49269", light: "#eed8a9", deep: "#7d6f4e" },
        { id: 5, name: "Charcoal", base: "#4a4e58", shadow: "#383b43", light: "#545861", deep: "#2b2d33" },
        { id: 6, name: "Rust", base: "#b0603a", shadow: "#86492c", light: "#c27b5a", deep: "#66351e" },
        { id: 7, name: "Royal", base: "#5a4ec8", shadow: "#443b98", light: "#7b71dc", deep: "#312a74" },
        { id: 8, name: "Bone", base: "#e6e0d0", shadow: "#afaa9e", light: "#fdf8ea", deep: "#858278" },
      ],
    },
    {
      key: "legs",
      label: "Legs",
      classes: ["pants", "cargo", "leggings", "leather", "boot", "satchel", "shade_boot", "shade_satchel"],
      swatches: [
        { id: 1, name: "Trail Brown", base: "#6e4c2c", shadow: "#543a21", light: "#795b3f", deep: "#402b18" },
        { id: 2, name: "Olive", base: "#6a7440", shadow: "#515831", light: "#778052", deep: "#3d4324" },
        { id: 3, name: "Iron", base: "#55606c", shadow: "#414952", light: "#636c77", deep: "#31373f" },
        { id: 4, name: "Ink Navy", base: "#2f3a56", shadow: "#242c41", light: "#3c465f", deep: "#1a2132" },
        { id: 5, name: "Ash Grey", base: "#7a7a72", shadow: "#5d5d57", light: "#86867f", deep: "#474742" },
        { id: 6, name: "Chestnut", base: "#7c4a30", shadow: "#5e3824", light: "#885c46", deep: "#48291a" },
        { id: 7, name: "Moss", base: "#4c6034", shadow: "#3a4928", light: "#586a43", deep: "#2c381d" },
        { id: 8, name: "Tar", base: "#35322e", shadow: "#282623", light: "#3a3834", deep: "#1f1d1a" },
      ],
    },
    {
      key: "hair",
      label: "Hair",
      classes: ["hair"],
      swatches: [
        { id: 1, name: "Raven", base: "#2b2429", shadow: "#211b1f", light: "#2f292e", deep: "#191518" },
        { id: 2, name: "Chestnut", base: "#8a4a26", shadow: "#69381d", light: "#985f40", deep: "#502913" },
        { id: 3, name: "Flax", base: "#d8b464", shadow: "#a4894c", light: "#eece88", deep: "#7d6737" },
        { id: 4, name: "Auburn", base: "#a33f22", shadow: "#7c301a", light: "#b35b42", deep: "#5f2210" },
        { id: 5, name: "Ash", base: "#9a9488", shadow: "#757067", light: "#a9a49a", deep: "#59564e" },
        { id: 6, name: "Plum", base: "#5c3a5e", shadow: "#462c47", light: "#664867", deep: "#352137" },
        { id: 7, name: "Copper", base: "#c06a28", shadow: "#92511e", light: "#d3884d", deep: "#6f3b13" },
        { id: 8, name: "Snow", base: "#e8e4dc", shadow: "#b0ada7", light: "#fffbf4", deep: "#87847f" },
      ],
    },
    {
      key: "skin",
      label: "Skin",
      classes: ["skin"],
      swatches: [
        { id: 1, name: "Fair", base: "#f6c79c", shadow: "#bb9777", light: "#ffd8b4", deep: "#8f7258" },
        { id: 2, name: "Tan", base: "#d99a68", shadow: "#a5754f", light: "#efb78b", deep: "#7e5739" },
        { id: 3, name: "Amber", base: "#b8763f", shadow: "#8c5a30", light: "#ca9060", deep: "#6b4321" },
        { id: 4, name: "Umber", base: "#8d5a34", shadow: "#6b4428", light: "#9b6e4d", deep: "#52331c" },
        { id: 5, name: "Deep", base: "#6b4227", shadow: "#51321e", light: "#76523a", deep: "#3e2515" },
      ],
    },
  ],
} as const;
